import axios, { Axios } from "axios";
import { instance } from "config/axiosInstance";
import { cookies } from "utils/cookies";

// note: declare base url
const baseURL = process.env.REACT_APP_BIMA_BE_FILE;

export async function uploadFile({ pathname, body }) {
  return await axios.post(`${baseURL}/files` + pathname, body, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${cookies?.get("token")?.token || cookies.get("refreshToken")?.refreshToken}`,
    },
  });
}
